import styled from "styled-components"

import Category from "./Category"
import ProductOrDeal from "./ProductOrDeal"

export const Products = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(25rem, 1fr));
  grid-gap: 1.5rem;
  margin-top: -1.5rem;
  margin-bottom: 3rem;
`

export const StyledCategory = styled(Category)`
  margin-bottom: 3rem;
`

export const StyledProductOrDeal = styled(ProductOrDeal)``
